import React from 'react';
import './suggestion-type-row.css';

const SuggestionTypeRow = ({ signal, icon, label, enabled, onEnabledChange, disabled, children }) => {
  const rowClassName = disabled ? 'suggestion-type-row disabled' : 'suggestion-type-row';
  const checkboxId = `signal-${signal}`;
  
  return (
    <div className={rowClassName}>
      <div className="signal-label">
        <input
          type="checkbox"
          id={checkboxId}
          checked={enabled}
          onChange={(e) => onEnabledChange(e.target.checked)}
          disabled={disabled}
        />
        <label htmlFor={checkboxId}>
          <span className="icon">{icon}</span>
          {label}
        </label>
      </div>
      <div className="signal-control">
        {children}
      </div>
    </div>
  );
};

export default SuggestionTypeRow;
